import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { Card } from "primereact/card";
import { ROUTES } from "../../config/routes";

const MetadataAudit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = useSelector((state: any) => state.googleAuth.user);
  const isAdmin = currentUser?.roles?.role === "admin";
  const [activeIndex, setActiveIndex] = useState(0);

  const tabPaths = useMemo(
    () => [
      ROUTES.METADATA_AUDIT_TITLE_QC,
      ROUTES.METADATA_AUDIT_DICTIONARY,
      ...(isAdmin ? [ROUTES.METADATA_AUDIT_ADMIN] : []),
    ],
    [isAdmin]
  );

  const items = useMemo(
    () => [
      { label: "Title QC", icon: "pi pi-file-edit" },
      { label: "Dictionary Settings", icon: "pi pi-book" },
      ...(isAdmin ? [{ label: "Admin", icon: "pi pi-cog" }] : []),
    ],
    [isAdmin]
  );

  useEffect(() => {
    const path = location.pathname;
    const idx = tabPaths.findIndex((p) => path === p || path.startsWith(`${p}/`));
    setActiveIndex(idx >= 0 ? idx : 0);
  }, [location.pathname, tabPaths]);

  const handleTabChange = (e: { index: number }) => {
    setActiveIndex(e.index);
    navigate(tabPaths[e.index]);
  };

  return (
    <PageContainer
      HomeMenuBarprops={{
        title: (
          <span
            style={{ cursor: "pointer", fontWeight: "bold" }}
            onClick={() => navigate(ROUTES.METADATA_AUDIT)}
          >
            Metadata Audit
          </span>
        ),
        Tabs: (
          <TabMenu
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            model={items}
          />
        ),
      }}
    >
      <div style={{ width: "96%", margin: "0 auto" }}>
        <Card unstyled style={{ marginTop: "2rem", boxShadow: "none" }}>
          <Outlet />
        </Card>
      </div>
    </PageContainer>
  );
};

export default MetadataAudit;
